import React, { Component } from "react";
import PaymentsSetupComponent from "../../../../containers/PaymentsSetup";
import queryString from "query-string";

class PaymentsSetup extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.setState({ sponsorId: this.props.match.params.sponsor_id });
  }

  fromRefresh = () => {
    const { location } = this.props;
    const parsedQueryString = queryString.parse(location.search);
    return parsedQueryString.refresh === "true";
  };

  render() {
    const { sponsorId } = this.state;

    return sponsorId ? (
      <PaymentsSetupComponent
        resourceType="sponsor"
        resourceId={sponsorId}
        refresh={this.fromRefresh()}
      />
    ) : (
      <div>...</div>
    );
  }
}

export default PaymentsSetup;
